<div class="alert {{ alertClass }}" role="alert">
  <div>{{ refusal.message }}</div>
  <button type="button"
          class="btn btn-sm btn-outline-secondary alert-btn mt-2"
          [disabled]="refusal.checking"
          [class.disabled]="refusal.checking"
          (click)="handleCheckAgain()">
    {{ refusal.checking ? 'Checking...' : 'Check again' }}
  </button>
  <div class="small mt-2" *ngIf="refusal.lastCheckAt">
    Still showing as live on the terminal. Checked at {{ lastCheckTimeDisplay() }}.
  </div>
</div>
